export default __webpack_public_path__ + "static/media/ISTJ.7d2ce1f0.svg";